/* Mikaya — desktop hover-to-open for the Shop mega menu.
   Click + keyboard still work (native <details> + Sense's header-menu).
   Hover is a desktop-only enhancement. */
(function () {
  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (hm) {
    var details = hm.querySelector('details.mega-menu');
    if (!details) return;
    var closeTimer;

    hm.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      window.clearTimeout(closeTimer);
      details.setAttribute('open', '');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    hm.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      closeTimer = window.setTimeout(function () {
        details.removeAttribute('open');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });
  });

  /* Mobile drawer: the custom Shop accordion (.mk-drawer-acc) is plain native
     <details>. Sense's MenuDrawer JS binds to every <summary> and adds the
     `submenu-open` class to the parent menu, sliding the whole drawer off-screen
     — which made tapping Shop look broken. Intercept those summary clicks in the
     capture phase so MenuDrawer's handler never runs; the native <details> toggle
     still fires and the panel opens inline. */
  document.addEventListener(
    'click',
    function (e) {
      var s = e.target.closest && e.target.closest('.mk-drawer-acc__summary');
      if (s) e.stopPropagation();
    },
    true
  );
})();
